// src/createJuicePlugin.ts
import {
  createPluginFactory,
  KEY_DESERIALIZE_HTML
} from "@udecode/plate-common";
import juice from "juice";
var KEY_JUICE = "juice";
var createJuicePlugin = createPluginFactory({
  key: KEY_JUICE,
  inject: {
    pluginsByKey: {
      [KEY_DESERIALIZE_HTML]: {
        editor: {
          insertData: {
            transformData: (data) => {
              let newData = data.replaceAll(/<style>(\s*)<!--/g, "<style>");
              newData = juice(newData);
              return newData;
            }
          }
        }
      }
    }
  }
});
export {
  KEY_JUICE,
  createJuicePlugin
};
//# sourceMappingURL=index.mjs.map